import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

interface P2pCardSkeletonProps {
	className?: string
}

export function P2pCardSkeleton({ className }: P2pCardSkeletonProps) {
	return (
		<div
			className={cn(
				'relative flex flex-col gap-2 overflow-hidden rounded-2xl border border-border bg-secondary p-2 pb-2 pt-3',
				'[clip-path:polygon(0%_0%,100%_0%,100%_100%,75%_100%,65%_95%,35%_95%,25%_100%,0%_100%)]',
				className,
			)}
		>
			<div className='flex items-center gap-3 px-2'>
				<Skeleton className='h-9 w-9 shrink-0 rounded-lg' />
				<div className='flex-1 space-y-2'>
					<Skeleton className='h-4 w-3/4' />
					<Skeleton className='h-3 w-1/2' />
				</div>
				<Skeleton className='h-9 w-16 shrink-0 rounded-lg' />
			</div>
			<div className='space-y-2 rounded-xl bg-background p-2'>
				<Skeleton className='h-8 w-full' />
				<Skeleton className='h-8 w-full' />
				<Skeleton className='h-10 w-full rounded-lg' />
			</div>
			<div className='flex items-center justify-between px-2 pb-1'>
				<Skeleton className='h-3 w-16' />
				<Skeleton className='h-3 w-20' />
			</div>
			<span className='pointer-events-none absolute bottom-1.5 left-1/2 h-1 w-10 -translate-x-1/2 rounded-full bg-border' />
		</div>
	)
}
